export function setMembership (state, newMebership) {
	const existingMembershipIndex = state.memberships.findIndex(membership => membership.id === newMebership.id);

	if (existingMembershipIndex >= 0) {
		return state.memberships[existingMembershipIndex] = {
			...newMebership
		};
	}

	state.memberships.push(newMebership);
}
